// src/UsuarioCadastro.js
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { api } from './api';
import { recarregar } from './dados';

// --- ÍCONES ---
const PencilIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>;
const WhatsAppIcon = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="h-4 w-4 inline-block mr-1" fill="currentColor"><path d="M380.9 97.1C339.2 55.4 283.4 32 224 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111l-29.5 101.4c-1.4 5.1.7 10.7 5.7 12.1 1.6.4 3.3.6 5 .6 4.6 0 8.9-2 11.8-5.3l37.9-52.5c27.1 12.3 57.3 18.9 88.5 18.9 122.4 0 222-99.6 222-222 0-53.1-18.3-102.7-50.5-138.9zM224 416c-32.5 0-62.7-8.9-88.8-24.4l-6.3-3.7-40.7 56.4 15.9-54.9-3.7-6.3c-15.5-26.1-24.4-56.3-24.4-88.8 0-101.4 82.3-183.6 183.6-183.6 50.1 0 97.4 19.5 133.5 55.6 36.1 36.1 55.6 83.4 55.6 133.5 0 101.4-82.3 183.6-183.6 183.6zM343.9 167.3c-2.3-2.3-5.3-3.7-8.8-3.7-3.5 0-6.5 1.4-8.8 3.7-10.8 10.8-28.3 10.8-39.1 0-10.8-10.8-10.8-28.3 0-39.1 10.8-10.8 28.3-10.8 39.1 0 10.8 10.8 10.8 28.3 0 39.1zM288 336c-23.4 0-46.7-6.9-67.4-20.1-1.3-.8-2.6-1.7-3.9-2.7-11.8-9.3-20.9-20.6-27.4-33.1-6.5-12.5-9.7-25.9-9.7-39.5 0-13.6 3.2-27 9.7-39.5 6.5-12.5 15.6-23.8 27.4-33.1 1.3-.9 2.6-1.8 3.9-2.7-20.7-13.2-44-20.1-67.4-20.1s46.7 6.9 67.4 20.1c1.3.9 2.6 1.8 3.9 2.7 11.8 9.3 20.9 20.6 27.4 33.1 6.5 12.5 9.7 25.9 9.7 39.5 0 13.6-3.2 27-9.7 39.5-6.5 12.5-15.6 23.8-27.4 33.1-1.3.9-2.6 1.7-3.9 2.7-20.7 13.2-44 20.1-67.4-20.1zM224 288c-13.8 0-25-11.2-25-25s11.2-25 25-25 25 11.2 25 25-11.2 25-25 25z"/></svg>;
// --- FIM ÍCONES ---

const UsuarioCadastro = ({
    usuarios,
    empresas,
    currentUser,
    setCurrentView,
    preselectedCompanyId,
    onUserCreated,
    initialData,
    onDeleteUsuario,
}) => {
    const [nome, setNome] = useState('');
    const [telefone, setTelefone] = useState('');
    const [setor, setSetor] = useState('');
    const [empresaSelecionadaId, setEmpresaSelecionadaId] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editingUserId, setEditingUserId] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [error, setError] = useState('');

    const usuariosFiltradosPorEmpresa = useMemo(() => {
        if (!empresaSelecionadaId) {
            return [];
        }
        return usuarios.filter(user => user.empresaId === empresaSelecionadaId);
    }, [usuarios, empresaSelecionadaId]);

    useEffect(() => {
        console.log("UsuarioCadastro - useEffect disparado. Current time:", new Date().toLocaleTimeString());
        console.log("initialData (Usuario):", initialData);
        console.log("preselectedCompanyId:", preselectedCompanyId);

        if (initialData && initialData.idFirebase) {
            console.log("Modo edição de usuário.");
            setIsEditing(true);
            setEditingUserId(initialData.idFirebase);
            setNome(initialData.nome || '');
            setTelefone(initialData.telefone || '');
            setSetor(initialData.setor || '');
            setEmpresaSelecionadaId(initialData.empresaId || '');
            setShowForm(true);
        } else if (preselectedCompanyId) {
            console.log("Modo novo usuário para empresa pré-selecionada.");
            setIsEditing(false);
            setEditingUserId(null);
            setNome('');
            setTelefone('');
            setSetor('');
            setEmpresaSelecionadaId(preselectedCompanyId);
            setShowForm(true);
        } else {
            console.log("Modo padrão/limpo.");
            setIsEditing(false);
            setEditingUserId(null);
            setNome('');
            setTelefone('');
            setSetor('');
            setEmpresaSelecionadaId('');
            setShowForm(false);
        }
        setError('');
    }, [initialData, preselectedCompanyId]);

    const handleEmpresaChange = (e) => {
        const id = e.target.value;
        setEmpresaSelecionadaId(id);
        setNome('');
        setTelefone('');
        setSetor('');
        setIsEditing(false);
        setEditingUserId(null);
        setShowForm(true);
        setError('');
    };

    const handleEditUser = (userToEdit) => {
        setIsEditing(true);
        setEditingUserId(userToEdit.idFirebase);
        setNome(userToEdit.nome || '');
        setTelefone(userToEdit.telefone || '');
        setSetor(userToEdit.setor || '');
        setEmpresaSelecionadaId(userToEdit.empresaId || '');
        setShowForm(true);
        setError('');
    };

    const handleNewUserClick = () => {
        if (!empresaSelecionadaId) {
            alert('Por favor, selecione uma empresa primeiro para adicionar um novo usuário.');
            return;
        }
        setIsEditing(false);
        setEditingUserId(null);
        setNome('');
        setTelefone('');
        setSetor('');
        setShowForm(true);
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!empresaSelecionadaId) {
            setError('Por favor, selecione uma empresa para vincular o usuário.');
            return;
        }

        if (!nome || !telefone) {
             setError('Por favor, preencha o Nome e o Telefone do usuário.');
             return;
        }

        try {
            const userData = {
                nome: nome.toUpperCase(),
                telefone: telefone.toUpperCase(),
                setor: setor.toUpperCase(),
                empresaId: empresaSelecionadaId,
            };

            // o servidor confere nome repetido na empresa e devolve o motivo
            if (isEditing && editingUserId) {
                const r = await api.put(`/usuarios/${editingUserId}`, userData);
                await recarregar('usuarios');
                if (r.pendenciasAtualizadas) recarregar('pendencias');
                alert('Usuário atualizado com sucesso!');
            } else {
                const criado = await api.post('/usuarios', userData);
                await recarregar('usuarios');
                alert("Usuário cadastrado com sucesso!");
                if (onUserCreated) onUserCreated(criado);
            }
            setShowForm(false);
            setNome('');
            setTelefone('');
            setSetor('');
            setIsEditing(false);
            setEditingUserId(null);

        } catch (error) {
            console.error("Erro ao salvar usuário:", error);
            setError(error.message);
        }
    };

    const handleDeleteUser = useCallback(async (userId) => {
        if (!window.confirm("Tem certeza que deseja excluir este usuário? Esta ação é irreversível e pode afetar pendências relacionadas.")) {
            return;
        }

        try {
            // o servidor recusa se o usuário estiver em alguma pendência
            await api.del(`/usuarios/${userId}`);
            await recarregar('usuarios');
            alert('Usuário excluído com sucesso!');
            if (editingUserId === userId) {
                setNome('');
                setTelefone('');
                setSetor('');
                setIsEditing(false);
                setEditingUserId(null);
                setShowForm(false);
            }
            setError('');
        } catch (error) {
            console.error("Erro ao excluir usuário:", error);
            setError(error.message);
        }
    }, [editingUserId]);

    return (
        <div className="p-4 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-semibold mb-4">Gestão de Usuários</h2>

            <div className="mb-4">
                <label htmlFor="empresa" className="block text-sm font-medium text-gray-700">Selecione a Empresa</label>
                <select
                    id="empresa"
                    value={empresaSelecionadaId}
                    onChange={handleEmpresaChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    required
                >
                    <option value="">Selecione uma empresa para gerenciar usuários</option>
                    {empresas.map(emp => (
                        <option key={emp.idFirebase} value={emp.idFirebase}>
                            {emp.nome}
                        </option>
                    ))}
                </select>
            </div>

            {empresaSelecionadaId && (
                <>
                    <div className="flex justify-end mb-4">
                        <button
                            type="button"
                            onClick={handleNewUserClick}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                        >
                            + Novo Usuário para {empresas.find(e => e.idFirebase === empresaSelecionadaId)?.nome || ''}
                        </button>
                    </div>

                    {usuariosFiltradosPorEmpresa.length > 0 ? (
                        <div className="mb-6">
                            <h3 className="text-xl font-semibold mb-3 text-gray-800">Usuários de {empresas.find(e => e.idFirebase === empresaSelecionadaId)?.nome || ''}</h3>
                            <div className="overflow-x-auto bg-white rounded-md shadow-md">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                ID
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Nome
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Telefone
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Setor
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Ações
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {usuariosFiltradosPorEmpresa.map((user) => (
                                            <tr key={user.idFirebase}>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600">
                                                    {user.nrUsuarioSequencial}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    {user.nome}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {user.telefone}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {user.setor}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex items-center">
                                                    <button
                                                        type="button"
                                                        onClick={() => handleEditUser(user)}
                                                        className="text-indigo-600 hover:text-indigo-900 flex items-center mr-2"
                                                        title="Editar Usuário"
                                                    >
                                                        <PencilIcon className="mr-1" /> Editar
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeleteUser(user.idFirebase)}
                                                        className="text-red-600 hover:text-red-900 flex items-center"
                                                        title="Excluir Usuário"
                                                    >
                                                        Excluir
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : (
                         <p className="text-center text-gray-500 mt-4">Nenhum usuário encontrado para esta empresa.</p>
                    )}
                </>
            )}

            {showForm && (
                <form onSubmit={handleSubmit} className="space-y-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <h3 className="text-xl font-semibold mb-3 text-gray-800">{isEditing ? 'Editar Usuário' : 'Novo Usuário'}</h3>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Empresa Selecionada</label>
                        <input
                            type="text"
                            value={empresas.find(e => e.idFirebase === empresaSelecionadaId)?.nome || ''}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-gray-100 cursor-not-allowed"
                            disabled
                        />
                    </div>

                    <div>
                        <label htmlFor="nome" className="block text-sm font-medium text-gray-700">Nome do Usuário</label>
                        <input
                            type="text"
                            id="nome"
                            value={nome}
                            onChange={(e) => setNome(e.target.value.toUpperCase())}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                            required
                        />
                    </div>

                    <div>
                        <label htmlFor="telefone" className="block text-sm font-medium text-gray-700">Telefone</label>
                        <input
                            type="text"
                            id="telefone"
                            value={telefone}
                            onChange={(e) => setTelefone(e.target.value.toUpperCase())}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                            required
                        />
                    </div>

                    <div>
                        <label htmlFor="setor" className="block text-sm font-medium text-gray-700">Setor</label>
                        <input
                            type="text"
                            id="setor"
                            value={setor}
                            onChange={(e) => setSetor(e.target.value.toUpperCase())}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={() => {
                                setShowForm(false);
                                setError('');
                            }}
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                        >
                            {isEditing ? 'Atualizar Usuário' : 'Cadastrar Usuário'}
                        </button>
                    </div>
                </form>
            )}

            <div className="flex justify-start mt-6">
                 <button
                    type="button"
                    onClick={() => setCurrentView('pendencias')}
                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                >
                    Voltar para Pendências
                </button>
            </div>
        </div>
    );
};

export default UsuarioCadastro;